(function () {
  Drupal.behaviors.esearchHeaderMobileV1 = {
    attach: function (context, settings) {
      var qs = generic.env.parsedQuery(),
        undef;

      // Populate and show the counter and term
      $(context).on('endeca.search.results.loaded', function (event, data) {
        var numResults = data.meta.totalAggrRecords || 0,
          searchTerm = data.searchTerm || '';
        var $count = $('.search-form__results-count', '.search-results__header');

        $count
          .find('.number')
          .text(numResults)
          .end()
          .find('.term')
          .text(searchTerm)
          .end()
          .removeClass('hidden');
      });
    }
  };
})(jQuery);
